import {
  CaseRotationStatus,
  NEW_CASES_ROTATION_GROUP,
  OFF_OCS_STATUSES,
  type ENOPCaseStatus,
} from '#entities';

// Helper for expanding rotation custom statuses
export const expandActiveStatuses = (
  active?: CaseRotationStatus,
): ReadonlySet<ENOPCaseStatus> => {
  if (!active || active === NEW_CASES_ROTATION_GROUP) {
    return new Set();
  }

  if ((OFF_OCS_STATUSES as readonly CaseRotationStatus[]).includes(active)) {
    return new Set(OFF_OCS_STATUSES as readonly ENOPCaseStatus[]);
  }

  return new Set([active as ENOPCaseStatus]);
};
